import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BubblesIcon = createIcon({
  displayName: 'BubblesIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <circle
        cx="18"
        cy="10"
        r="3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="11.5"
        cy="17.5"
        r="3.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="7"
        cy="7"
        r="4"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20,17.50064A.5.5,0,1,1,19.49937,17,.5.5,0,0,1,20,17.50064"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15,3.50063A.5.5,0,1,1,14.49937,3,.5.5,0,0,1,15,3.50063"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.50063,15.00063A.5.5,0,1,1,4,14.5a.5.5,0,0,1,.50064.50063"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const Bubbles: FC<IconProps> = (props) => {
  return <CustomIcon as={BubblesIcon} {...props} />
}

export default memo(Bubbles)
